import { Banner as BannerReExportForCsr } from './main.tsx';

export const Banner = BannerReExportForCsr;
